import React, { useEffect, useContext } from 'react';
import { MDBContainer, MDBCol, MDBRow, } from 'mdb-react-ui-kit';
import '../App.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";

import ConfirmPassword from "./ConfirmPassword"


function ResetPassword() {
 
  // console.log("I AM printed")


  // useEffect(() => {
  //   if (isLoggedIn) {
  //     navigate('/home');
  //   }
  // }, []);

  return (
    <div className="container-wrapper">
      <MDBContainer fluid className="p-4 my-5 h-custom">
        <MDBRow >
          <MDBCol col='6' md='6' >
            <img src="/logo.png" className="img-fluid" alt="Sampleimage" />
          </MDBCol>
          <MDBCol col='3' md='5' style={{ margin: "auto" }} >
            <ConfirmPassword/>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
}
export default ResetPassword;